import React from "react";
import { FileCode2 } from "lucide-react";
import { CodePathForm } from "../components/CodePathForm";
import { SectionShell } from "../layout";
import type { RuntimeType, SectionControlProps } from "../types";

export const SourceSection: React.FC<
  SectionControlProps & {
    summary: string;
    codeSource: string;
    onCodeSourceChange: (source: string) => void;
    codeSourceType: "url/upload" | "embedded" | "none" | "";
    onCodeSourceTypeChange: (type: "url/upload" | "embedded" | "none") => void;
    codeSourceError: string | null;
    onCodeSourceErrorChange: (error: string | null) => void;
    runtimeType: RuntimeType;
  }
> = ({
  summary,
  codeSource,
  onCodeSourceChange,
  codeSourceType,
  onCodeSourceTypeChange,
  codeSourceError,
  onCodeSourceErrorChange,
  runtimeType,
  ...sectionProps
}) => (
  <SectionShell
    id="source"
    title="Source"
    summary={summary}
    icon={<FileCode2 className="h-5 w-5" />}
    {...sectionProps}
  >
    <CodePathForm
      codeSource={codeSource}
      onCodeSourceChange={onCodeSourceChange}
      codeSourceType={codeSourceType}
      setCodeSourceType={onCodeSourceTypeChange}
      codeSourceError={codeSourceError}
      setCodeSourceError={onCodeSourceErrorChange}
      showEmbeddedCodeOption={
        runtimeType === "container" || runtimeType === "kubernetes"
      }
    />
  </SectionShell>
);
